import React from "react";
import {Box, Typography} from "@mui/material";

interface ErrorProps {
    message?: string;
}

const ErrorMessage: React.FC<ErrorProps> = ({message}) => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="70vh"
        >
            <Typography variant="h4" gutterBottom>
                {message ?? "Nepodařilo se načíst data..."}
            </Typography>
        </Box>
    );
}

export default ErrorMessage;